import React from "react";
import {Form, FormGroup} from "src/interfaces/form";
import {SettingsType, WidgetSettings} from "src/interfaces/settings";
import {useTranslation} from "react-i18next";
import Footer from "../widget/ui/Footer";

interface Props {
  showFooter: boolean;
  header: React.ReactNode;
  formsOnly?: boolean;

  languageCode: string;
  widgetSettings: WidgetSettings;
  contextSettings: SettingsType;

  formGroup: FormGroup;
  onSelect: (form: Form) => void;
}

export function FormSelectionMenu({
  widgetSettings,
  contextSettings,
  languageCode,
  formGroup,
  header,
  onSelect,
  showFooter,
  formsOnly,
}: Props) {
  const {t} = useTranslation();
  const style = {
    style: {
      backgroundColor: `${widgetSettings?.categoryButtonColor}`,
      color: `${widgetSettings?.categoryButtonTextColor}`,
    },
  };
  const forms = contextSettings.langs?.[languageCode]?.formGroups?.find((fg) => fg.title === formGroup.title)?.forms;

  return (
    <React.Fragment>
      {header}
      <main className="faq-widget-main" style={{paddingTop: formsOnly ? "24px" : ""}}>
        <div className="faq-widget-main-top">
          {formGroup.forms.length === 0 && (
            <h2>{widgetSettings?.[languageCode]?.noFormsFoundText || t("NO_FORMS_FOUND")}</h2>
          )}
          {formGroup.forms.length > 0 && (
            <>
              <h2>{widgetSettings.langs?.[languageCode]?.formSelectionTitle || t("SELECT_FORM")}</h2>
              <div className="faq-widget-categories-container">
                {forms?.map((form) => {
                  return (
                    <button
                      className="faq-widget-category w-full"
                      {...style}
                      key={form.id}
                      onClick={() => onSelect(form)}
                      title={form.name}
                    >
                      <p className="truncated-text font-semibold ">{form.name}</p>
                    </button>
                  );
                })}
              </div>
            </>
          )}
        </div>
        {showFooter && widgetSettings?.footerEnabled && <Footer />}
      </main>
    </React.Fragment>
  );
}
